<template>
  <m-pay-generic-editor
    :loading="loading"
    :bean="widgetItem"
    :beanPropertyValues="beanPropertyValues"
    :beanProperties="editableProperties"
    :validationRules="editableRules"
    @cancel="cancel"
    @submit="submit"
  />
</template>

<script>

import MPayGenericEditor from '../MPayGenericEditor';

export default {

  name: 'MPayWidgetItemEditor',

  props: {
    loading: { type: Boolean, required: false, default: false },
    widgetItem: { type: Object, required: true },
  },

  components: { MPayGenericEditor },

  data: () => ({

    editableProperties: [
      'reference',
      'label',
      'amount',
      'currency',
      'taxRate',
      'count',
    ],
    editableRules: [
      'required|max:255',
      'required|max:255',
      'decimal:2',
      'required',
      'decimal:2|max_value:1',
      'numeric|min_value:1',
    ],
  }),

  computed: {
    beanPropertyValues() {
      return {
        currency: [
          'EUR',
        ],
      };
    },
  },

  methods: {
    submit(bean) {
      this.$emit('submit', bean);
    },
    cancel() {
      this.$emit('cancel');
    },
  },

};
</script>




// WEBPACK FOOTER //
// src/components/merchant/MPayWidgetItemEditor.vue